import { useQuery, queryOptions } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import { fetchPlacesByCategory, fetchPlacesByName, fetchPlaceDetails } from '../api/placesApi';

import { mapSearchKeys } from './keys';

export const placesByCategoryOptions = (category, bounds, zoom) =>
	queryOptions({
		queryKey: mapSearchKeys.places(category, bounds, zoom),
		queryFn: async () => {
			const result = await fetchPlacesByCategory(category, bounds);
			// Backend returns { success, count, data }
			return result.data || [];
		},
		staleTime: STALE_TIMES.STABLE,
	});

export function usePlacesByCategory(category, bounds, zoom) {
	return useQuery({
		...placesByCategoryOptions(category, bounds, zoom),
		enabled: Boolean(category) && Boolean(bounds) && zoom >= 13,
	});
}

export const placesByNameOptions = (query, bounds) =>
	queryOptions({
		queryKey: mapSearchKeys.searchByName(query, bounds),
		queryFn: async () => {
			const result = await fetchPlacesByName(query, bounds);
			// Backend returns { success, count, data }
			return result.data || [];
		},
		staleTime: STALE_TIMES.STABLE,
	});

export function usePlacesByName(query, bounds) {
	return useQuery({
		...placesByNameOptions(query, bounds),
		enabled: Boolean(query) && query.length >= 2 && Boolean(bounds),
	});
}

export const placeDetailsOptions = (placeId) =>
	queryOptions({
		queryKey: mapSearchKeys.placeDetails(placeId),
		queryFn: async () => {
			const result = await fetchPlaceDetails(placeId);
			// Backend returns { success, data }
			return result.data || null;
		},
		staleTime: STALE_TIMES.STABLE,
	});

export function usePlaceDetails(placeId) {
	return useQuery({
		...placeDetailsOptions(placeId),
		enabled: Boolean(placeId),
	});
}
